/*eslint-disable */

export default {
  getPassionProjectResponse(state) {
    return state.passionProjectResponse
  },
  getLastUpdatedTime(state) {
    return state.lastUpdatedTime
  }
}